/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  initialQueryState,
  PaginationState,
  QUERIES,
  WithChildren,
} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from './QueryRequestProvider'
import {getAll} from '../../../../services/common_requests'
import { createAboutResponseContext, About, initialAboutQueryResponse,  } from './_models'

const QueryAboutResponseContext = createAboutResponseContext<About>(initialAboutQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<any>(state)
  const updatedQuery = useMemo(() => state, [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching: isFetchingAbouts,
    refetch: refetchData,
    data: dataResponse,
  } = useQuery(
    `${QUERIES.ABOUT_PAGE}-${JSON.stringify(query)}`,
    () => {
      return getAll(query, '/sectionOne')
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <QueryAboutResponseContext.Provider
      value={{
        isLoading: isFetchingAbouts,
        refetchData,
        dataResponse,
        query,
      }}
    >
      {children}
    </QueryAboutResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryAboutResponseContext)

const useQueryResponseData = () => {
  const {dataResponse} = useQueryResponse();

  console.log('****dataResponse', JSON.stringify(dataResponse));
;
  if (!dataResponse) {
    return [];  
  }
  return dataResponse.data;  
}
const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {dataResponse} = useQueryResponse()
  if (!dataResponse || !dataResponse.payload || !dataResponse.pagination) {
    return defaultPaginationState
  }

  return dataResponse.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
